import React from 'react'

import GoodItem from './GoodItem'

const ListItem = ({ item }) => <GoodItem good={item} />

export default ListItem
